export default {
  AU: [
    '(UTC+10:30) Lord Howe Island',
    '(UTC+10:00) Hobart',
    '(UTC+10:00) Canberra, Melbourne, Sydney',
    '(UTC+09:30) Adelaide',
    '(UTC+10:00) Brisbane',
    '(UTC+09:30) Darwin',
    '(UTC+08:00) Perth',
    '(UTC+08:45) Eucla'
  ],
  NZ: ['(UTC+12:00) Auckland, Wellington', '(UTC+12:45) Chatham Islands'],
  MY: ['(UTC+08:00) Kuala Lumpur, Singapore'],
  SG: ['(UTC+08:00) Kuala Lumpur, Singapore'],
  US: [
    '(UTC-10:00) Hawaii',
    '(UTC-09:00) Alaska',
    '(UTC-08:00) Pacific Time (US & Canada)',
    '(UTC-07:00) Mountain Time (US & Canada)',
    '(UTC-06:00) Central Time (US & Canada)',
    '(UTC-05:00) Eastern Time (US & Canada)'
  ],
  GB: ['(UTC+00:00) Dublin, Edinburgh, Lisbon, London'],
  CA: [
    '(UTC-08:00) Pacific Time (US & Canada)',
    '(UTC-07:00) Mountain Time (US & Canada)',
    '(UTC-06:00) Central Time (US & Canada)',
    '(UTC-05:00) Eastern Time (US & Canada)',
    '(UTC-04:00) Atlantic Time (Canada)',
    '(UTC-03:30) Newfoundland'
  ],
  CN: ['(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi'],
  JP: ['(UTC+09:00) Osaka, Sapporo, Tokyo'],
  KR: ['(UTC+09:00) Seoul'],
  IN: ['(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi'],
  ID: ['(UTC+07:00) Bangkok, Hanoi, Jakarta', '(UTC+08:00) Kuala Lumpur, Singapore', '(UTC+09:00) Osaka, Sapporo, Tokyo'],
  TH: ['(UTC+07:00) Bangkok, Hanoi, Jakarta'],
  VN: ['(UTC+07:00) Bangkok, Hanoi, Jakarta'],
  PH: ['(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi'],
  FR: ['(UTC+01:00) Brussels, Copenhagen, Madrid, Paris'],
  DE: ['(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'],
  ES: ['(UTC+01:00) Brussels, Copenhagen, Madrid, Paris', '(UTC+00:00) Dublin, Edinburgh, Lisbon, London'],
  IT: ['(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'],
  PT: ['(UTC+00:00) Dublin, Edinburgh, Lisbon, London', '(UTC-01:00) Azores'],
  BR: ['(UTC-05:00) Acre', '(UTC-04:00) Cuiaba', '(UTC-03:00) Brasilia', '(UTC-02:00) Mid-Atlantic'],
  MX: [
    '(UTC-08:00) Pacific Time (US & Canada)',
    '(UTC-07:00) Mountain Time (US & Canada)',
    '(UTC-06:00) Central Time (US & Canada)',
    '(UTC-05:00) Eastern Time (US & Canada)'
  ],
  RU: ['(UTC+03:00) Moscow, St. Petersburg', '(UTC+05:00) Ekaterinburg', '(UTC+07:00) Krasnoyarsk', '(UTC+09:00) Yakutsk', '(UTC+11:00) Vladivostok'],
  AE: ['(UTC+04:00) Abu Dhabi, Muscat'],
  SA: ['(UTC+03:00) Riyadh'],
  ZA: ['(UTC+02:00) Harare, Pretoria']
}
